<template>
  <div>
    <transition name="fade-out">
      <div class="cover" v-show="showCity">
        <div class="pop" ref="popref">
          <div v-if="!showdevliy">
            <!-- <p class="close" @click="close">
            <img src="../../assets/close-quick.png" alt="" />
          </p> -->
            <!-- <p class="text1" v-if="lang == 1">{{$t('select.welcome')}}</p> -->
            <p class="text2" v-if="lang == 1">{{ $t("select.chooseCity") }}</p>
            <p class="text3" v-if="lang == 2 || lang == 3">
              {{ $t("select.chooseCity") }}
            </p>
            <div class="local">
              <p class="list">
                <span
                  v-for="(item, index) in deliBefore"
                  :key="index"
                  :class="['place', { active: activeIndex1 == index }]"
                  @click="selectCity(item, index)"
                >
                  {{ item.CityName }}
                </span>
              </p>
            </div>
            <div class="nonlocal">
              <p class="list">
                <span
                  v-for="(item, index) in deliAfter"
                  :key="index"
                  :class="['place', { active: activeIndex2 == index }]"
                  @click="noLocalCity(item, index)"
                >
                  {{ item.CityName }}
                </span>
              </p>
            </div>
            <div class="otherCity">
              <div class="KeyValue">
                <p class="key">
                  <span
                    v-for="(key, index) in otherCity"
                    :key="index"
                    :class="['keyItem', { active: keyIndex == index }]"
                    @click="selectKey(key, index)"
                  >
                    {{ key.KeyValue }}
                  </span>
                </p>
              </div>
              <div class="city">
                <p class="keycity">
                  <i class="icon" :style="{ left: iconLeft + 'px' }"></i>
                  <span
                    v-for="(cityItem, index) in keyList"
                    :key="index"
                    :class="['cityItem', { active: otherIndex == index }]"
                    @click="selectOther(cityItem, index)"
                  >
                    {{ cityItem.CityName }}
                  </span>
                </p>
              </div>
            </div>
            <div class="btnBox">
              <div
                :class="['confirm', { active: isEnter }]"
                @mouseover.stop="enterbtn(true)"
                @mouseleave="leavebtn(false)"
                @click="confirm"
              >
                {{ $t("delivery.queren") }}
              </div>
              <div class="cancel" @click="close">
                {{ $t("delivery.quxiao") }}
              </div>
            </div>
          </div>

          <div class="deliverbox" v-if="showdevliy || isshowlu || ishowfly">
            <div class="jian" v-if="!showdevliy">
              <img src="../../assets/icon/ab.png" class="jiansty" alt="" />
            </div>
            <div class="titleBox" v-if="showdevliy">
              <div class="tip">{{ $t("delivery.del2") }}</div>
              <div class="cictyname">{{ cityName }}</div>
            </div>

            <div class="dechang" v-if="showdevliy">
              <span @click="changcity">{{ $t("delivery.del5") }}</span>
            </div>

            <div class="twoways">
              <div
                class="lu"
                v-if="isshowlu"
                @mouseenter.stop="Inlubtn()"
                @mouseleave.stop="outlubtn()"
              >
                <div v-if="!showHoveLu">
                  <img
                    class="waysty"
                    :src="ImgList.LandSelected"
                    alt=""
                    srcset=""
                    v-if="chooselu"
                  />
                  <img
                    class="waysty"
                    :src="ImgList.LandUnselect"
                    alt=""
                    srcset=""
                    v-else
                  />
                </div>
                <div v-else>
                  <!-- //悬浮图片 -->
                  <img
                    class="waysty"
                    :src="ImgList.LandPCHover"
                    alt=""
                    srcset=""
                    @click="landchose()"
                  />
                </div>
              </div>

              <div
                class="fly"
                v-if="ishowfly"
                @mouseenter.stop="Inflybtn()"
                @mouseleave.stop="outflybtn()"
              >
                <div v-if="!showHoveFly">
                  <img
                    class="waysty"
                    v-if="choosefly"
                    :src="ImgList.AirSelected"
                    alt=""
                    srcset=""
                  />
                  <img
                    class="waysty"
                    v-else
                    :src="ImgList.AirUnselect"
                    alt=""
                    srcset=""
                  />
                </div>
                <div v-else>
                  <img
                    class="waysty"
                    :src="ImgList.AirPCHover"
                    alt=""
                    srcset=""
                    @click="flychose()"
                  />
                </div>
              </div>
            </div>

            <!-- <div class="waysbtn">
              <div class="sure" @click="devliybtn">
                {{ $t("delivery.queren") }}
              </div>
              <div class="del" @click="closedev">
                {{ $t("delivery.quxiao") }}
              </div>
            </div> -->
          </div>
          <div v-if="showTip" ref="fretips" class="fre-tips">
            <img v-if="lang == 2"  src="../../assets/icon/fre_tip.png" alt="" />
            <img  v-if="lang == 3" src="../../assets/icon/aa.png" alt="" />
            <img  v-if="lang == 1" src="../../assets/icon/bb.png" alt="" />

          </div>
        </div>
        <div class="mask"></div>
      </div>
    </transition>

    <div class="app-cover" v-if="showApp">
      <div class="app-pop">
        <div class="inner">
          <h2>欢迎</h2>
          <p class="desc">
            该城市目前只能通过APP下单。<br />请扫描二维码下载APP：
          </p>
          <img src="../../assets/eqcode.png" />
          <span class="btn" @click.stop="back()">返回</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import filter from "../../plugins/filters";
export default {
  name: "vselectCity",
  props: {
    showCity: {
      type: Boolean,
      default: false,
    },
    showdevliy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showHoveLu: false,
      showHoveFly: false,
      lang: 1,
      iconLeft: 4,
      showApp: false,
      cityInfo: {},
      hotCity: [],
      deliBefore: [],
      deliAfter: [],
      isSelect: false,
      activeIndex1: null,
      activeIndex2: null,
      keyIndex: 0,
      otherIndex: null,
      otherCity: [],
      keyList: [],
      isEnter: false,

      ImgList: {},
      ishowfly: false,
      isshowlu: false,
      choosefly: false,
      chooselu: false,
      cityName: "",
      waynum: "",
      topnum: 0,
      screeHeight: 0,
      showTip: true,
    };
  },
  created() {
    this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : 1;
    //console.log("1111111111111111111111");
  },
  mounted() {
    // this.topnum = this.$refs.popref.getBoundingClientRect
    // this.$refs.cart.getBoundingClientRect()
    // console.log('this.topnum',this.$refs.popref.getBoundingClientRect  );

    // console.log("screenWidth", document.body.clientWidth);
    // console.log("screeHeight", document.body.clientHeight);

    // //  687px

    // const  screeHeight = document.body.clientHeight
    // console.log('600 >screeHeight',600 >screeHeight);
    // if(screeHeight <700 ){
    //   console.log('okokokokoko',  this.$refs.popref);
    //   this.$refs.popref.style.backgroundColor="red"
    //   this.$refs.popref.style.height="500px"
    //   this.$refs.popref.style.overflowY="auto"
    // }

    this.screeHeight = document.body.clientHeight;

    this.OpeningCity();
  },
  watch: {
    showCity(n, o) {
      //console.log("监听", n, o);
      if (n) {
        this.OpeningCity();
      }
    },
    showdevliy(n, o) {
      //console.log("监听2", n, o);
      let isme = false;
      if (n) {
        let cityDvliy = filter.readData("cityInfo");
        cityDvliy.DeliveryInfo.forEach((val) => {
          if (val.AreaType == 1) {
            isme = true;
          }
        });

        if (isme) {
          this.$emit("changeshowdevliy", false);

          this.ishowfly = false;
          this.isshowlu = false;
          return;
        }

        if (cityDvliy.IsHideDelivery) {
          this.$emit("changeshowdevliy", false);

          this.ishowfly = false;
          this.isshowlu = false;
          return;
        }

        const deArr = [];
        cityDvliy.DeliveryInfo.forEach((val) => {
          deArr.push(val.DeliveryMode);
        });

        if (deArr.indexOf(8) != -1) {
          this.ishowfly = true;
          //console.log("空运为真");
        }

        if (deArr.indexOf(9) != -1) {
          this.isshowlu = true;
          //console.log("陆运为真");
        }

        let lang = localStorage.getItem("lang");
        // let days = filter.readData("DeliveryMode");
        // let daystit = "";

        // cityDvliy.DeliveryInfo.forEach((val) => {
        //   if (val.DeliveryMode == days) {
        //     daystit = val.DeliveryCycle;
        //   }
        // });

        if (lang == 1) {
          this.cityName = filter.readData("cityInfo").CityNameCn;
        } else if (lang == 2) {
          this.cityName = filter.readData("cityInfo").CityNameEn;
        } else if (lang == 3) {
          this.cityName = filter.readData("cityInfo").CityNameFr;
        } else {
          this.cityName = filter.readData("cityInfo").CityNameCn;
        }
        //console.log(cityDvliy);
      }
    },
  },
  methods: {
    Inlubtn() {
      //console.log("进入陆运");
      this.showHoveFly = false;
      if (this.chooselu) {
        this.showHoveLu = false;
      } else {
        this.showHoveLu = true;
      }
    },
    outlubtn() {
      this.showHoveLu = false;
    },
    Inflybtn() {
      this.showHoveLu = false;
      //console.log("进入fly");
      if (this.choosefly) {
        this.showHoveFly = false;
      } else {
        this.showHoveFly = true;
      }
    },
    outflybtn() {
      this.showHoveFly = false;
    },
    changcity() {
      // this.showdevliy = false;
      this.$emit("changeshowdevliy", false);
      this.ishowfly = false;
      this.isshowlu = false;
    },
    landchose() {
      this.showTip = false;

      this.choosefly = false;
      this.chooselu = true;
      this.showHoveLu = false;
      this.waynum = 9;
      this.devliybtn();
      // filter.setData("DeliveryMode", 9);
    },
    flychose() {
      this.showTip = false;

      this.choosefly = true;
      this.chooselu = false;
      this.showHoveFly = false;
      this.waynum = 8;
      this.devliybtn();

      // filter.setData("DeliveryMode", 8);
    },
    closedev() {
      // this.ishowfly = false;
      // this.isshowlu = false;
      // this.choosefly = false;
      // this.chooselu = false;

      if (this.showdevliy) {
        //console.log("配送111");
        this.choosefly = false;
        this.chooselu = false;
        this.close();
      } else {
        //console.log("配送2222");

        this.ishowfly = false;

        this.isshowlu = false;
        this.choosefly = false;
        this.chooselu = false;
        // localStorage.removeItem("DeliveryMode");
      }
    },
    devliybtn() {
      let info = {};
      //console.log("deliver", deliver);
      let deliver = filter.readData("delivcity");
      // filter.setData("delivcity", currcity);
      if (deliver == null) {
        info = filter.readData("cityInfo");
      } else {
        info = filter.readData("delivcity");
      }

      //console.log("info", info);
      if (this.choosefly || this.chooselu) {
        // filter.setData("DeliveryMode", this.waynum);

        for (let i = 0; i < info.DeliveryInfo.length; i++) {
          if (info.DeliveryInfo[i].DeliveryMode == this.waynum) {
            filter.setData("waysobj", info.DeliveryInfo[i]);
            // filter.setData("cityInfo", info);
            this.$store.commit("set_areaType", info.DeliveryInfo[i].AreaType);
            this.$store.commit("set_CurrentCity", info.CityID);

            break;
          }
        }
        this.$emit("closeCity", false);
        this.$emit("getCity", info);
        filter.setData("cityInfo", info);

        localStorage.removeItem("delivcity");
      } else {
        alert(this.$t("delivery.del4"));
      }

      // if (this.choosefly || this.chooselu) {
      //   filter.setData("DeliveryMode", this.waynum);
      //   if (!this.showdevliy) {
      //     this.$emit("closeCity", false);
      //     this.$emit("getCity", this.cityInfo);
      //     this.$store.commit("set_areaType", this.cityInfo.AreaType);
      //     this.$store.commit("set_CurrentCity", this.cityInfo.CityID);
      //     filter.setData("cityInfo", this.cityInfo);
      //   } else {
      //     this.$emit("closeCity", false);
      //     this.$emit("getCity", info);
      //     this.$store.commit("set_areaType", info.AreaType);
      //     this.$store.commit("set_CurrentCity", info.CityID);
      //     filter.setData("cityInfo", info);
      //   }
      // } else {
      //   alert("未选择配送方式");
      // }
    },
    OpeningCity() {
      const _this = this;
      _this.$store
        .dispatch("OpeningCity", {
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then(({ Data }) => {
          _this.hotCity = Data.HotCity;
          if (_this.hotCity.length) {
            _this.deliBefore = this.hotCity.slice(0, 4);
            _this.deliAfter = this.hotCity.slice(4);
          }
          _this.otherCity = Data.CityList;
          _this.keyList = _this.otherCity[0].List;
          _this.ImgList = Data.ImgList1;
        });
    },
    selectCity(city, index) {
      //console.log("第一行的城市", city);
      this.ishowfly = false;
      this.isshowlu = false;
      this.choosefly = false;
      this.chooselu = false;

      this.activeIndex1 = index;
      this.activeIndex2 = null;
      this.keyIndex = null;
      this.otherIndex = null;
      this.cityInfo = city;
    },
    noLocalCity(city, index) {
      //console.log("第二行的城市", city);

      this.ishowfly = false;
      this.isshowlu = false;
      this.choosefly = false;
      this.chooselu = false;

      this.activeIndex2 = index;
      this.activeIndex1 = null;
      this.keyIndex = null;
      this.otherIndex = null;
      this.cityInfo = city;
    },
    selectKey(key, index) {
      this.keyIndex = index;
      this.iconLeft = 4 + index * 44;
      this.keyList = key.List;
      this.activeIndex2 = null;
      this.activeIndex1 = null;
      this.otherIndex = null;
    },
    selectOther(city, index) {
      //console.log("第三行的城市", city);
      //   改变空陆运状态
      this.ishowfly = false;
      this.isshowlu = false;
      this.choosefly = false;
      this.chooselu = false;
      // localStorage.removeItem("DeliveryMode");

      this.otherIndex = index;
      this.activeIndex2 = null;
      this.activeIndex1 = null;
      this.cityInfo = city;
    },
    enterbtn(val) {
      this.isEnter = val;
    },
    leavebtn(val) {
      this.isEnter = val;
    },
    confirm() {
      //console.log("确认选中的城市", this.cityInfo);
      // return
      if (JSON.stringify(this.cityInfo) == "{}") {
        alert("" + this.$t("select.choosePrompt1"));
        return;
      }
      if (this.cityInfo.IsNogogo) {
        window.location.href = "https://www.nogogo.cn/";
        return;
      }

      if (this.screeHeight < 800) {
        // this.$refs.popref.style.backgroundColor = "red";
        this.$refs.popref.style.height = "500px";
        this.$refs.popref.style.overflowY = "auto";
      }

      // this.$emit("closeCity", false); //子组件对showStatus修改后向父组件发送事件通知
      // this.$emit("getCity", this.cityInfo);
      // this.$store.commit("set_areaType", this.cityInfo.AreaType);
      // this.$store.commit("set_CurrentCity", this.cityInfo.CityID);
      // filter.setData("cityInfo", this.cityInfo);

      const currcity = this.cityInfo;
      filter.setData("delivcity", currcity);

      if (currcity.IsHideDelivery) {
        this.$store.commit("set_areaType", currcity.DeliveryInfo[0].AreaType);
        this.$store.commit("set_CurrentCity", currcity.CityID);
        filter.setData("waysobj", currcity.DeliveryInfo[0]);

        filter.setData("cityInfo", currcity);
        localStorage.removeItem("delivcity");
        this.showTip = false;

        this.$emit("getCity", this.cityInfo);
        this.$emit("closeCity", false);
        //console.log("余杭跳转");
      }

      // currcity.DeliveryInfo.forEach((res) => {
      //   if (res.AreaType == 1) {
      //     this.$emit("closeCity", false);
      //     this.$emit("getCity", this.cityInfo);
      //     this.$store.commit("set_areaType", this.cityInfo.AreaType);
      //     this.$store.commit("set_CurrentCity", this.cityInfo.CityID);
      //     filter.setData("cityInfo", this.cityInfo);
      //     return;
      //   }
      // });
      for (let i = 0; i < currcity.DeliveryInfo.length; i++) {
        if (currcity.DeliveryInfo[i].AreaType == 1) {
          this.$store.commit("set_areaType", currcity.DeliveryInfo[i].AreaType);
          this.$store.commit("set_CurrentCity", currcity.CityID);
          filter.setData("waysobj", currcity.DeliveryInfo[i]);
          this.showTip = false;

          filter.setData("cityInfo", currcity);
          localStorage.removeItem("delivcity");

          this.$emit("getCity", this.cityInfo);
          this.$emit("closeCity", false);
          //console.log("自营跳转");
          return;
        }
      }
      //console.log("非自营未跳转");

      const deArr = [];
      currcity.DeliveryInfo.forEach((val) => {
        deArr.push(val.DeliveryMode);
      });

      //console.log("deArr", deArr);

      if (deArr.indexOf(8) != -1) {
        this.ishowfly = true;
        //console.log("空运为真");
      }

      if (deArr.indexOf(9) != -1) {
        this.isshowlu = true;
        //console.log("陆运为真");
      }
    },
    close() {
      localStorage.removeItem("delivcity");

      this.$emit("closeCity", false); //子组件对showStatus修改后向父组件发送事件通知
    },
    back() {
      this.showApp = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/color.scss";
@import "../../style/base.scss";

.fade-out-leave-active {
  // top: 20px;
  // left: 40px;
  // transition: all 0.5s ease-out;
}

.fade-out-leave-to {
  animation: animationFrames linear 1s;
  animation-iteration-count: 1;
  transform-origin: 50% 50%;
}

@keyframes animationFrames {
  0% {
    opacity: 1;
    // transform: scale(1);
    // transform: translate(-27px, -23px);
  }
  50% {
    // opacity: 0;
    // transform: scale(0.5);
    // transform: translate(-100px, -20px);
    // transform: translate(-100px, -20px) scale(0.2);
  }
  100% {
    // opacity: 0;
    // transform: translate(-100px, -200px);
    // transform: translate(270px, -20px) scale(0);
    transform: translate(-400px, -20px) scale(0);
  }
}
.cover {
  // width: 100%;
  // height: 100%;
  // // background: rgba(0, 0, 0, 0.4);
  // position: fixed;
  // left: 0;
  // top: 0;
  // z-index: 9999;
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
  }
  .fre-tips {
    position: absolute;
    top: -70px;
    left: 0;
    transform: translateX(-100%);
    right: 72%;
    width: 350px;
    height: 520px;
  }
  .pop {
    position: fixed;
    left: 50%;
    top: 12%;

    transform: translateX(-50%);
    width: 800px;
    margin-top: 80px auto;
    background: #fff;
    border-radius: 20px;
    padding: 20px 0 25px;
    box-sizing: border-box;
    z-index: 9999;

    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }

    .close img {
      width: 30px;
      height: 30px;
    }

    .text1 {
      font-size: 30px;
      color: $c_6DB;
      text-align: center;
    }
    .text2 {
      font-size: 25px;
      color: $c_6DB;
      font-weight: 600;
      margin-bottom: 30px;
      text-align: center;
      font-family: "Montserrat-SemiBold";
    }
    .text3 {
      font-size: 25px;
      color: $c_6DB;
      margin-bottom: 30px;
      text-align: center;
      font-family: EperFontBold;
    }
    .local {
      text-align: center;
      margin: 0 auto;
      padding: 0 42px;
      box-sizing: border-box;
      margin-bottom: 20px;
      color: $c_000;
      .list {
        line-height: 24px;
      }
      .place {
        text-align: center;
        // width: 124px;
        padding: 0 10px;
        height: 26px;
        display: inline-block;
        font-size: 15px;
        cursor: pointer;
        font-family: EperFontLight;
      }
      .place.active {
        text-align: center;
        line-height: 24px;
        color: $c_6DB;
        border: 1px solid $c_6DB;
        border-radius: 15px;
      }
    }
    .nonlocal {
      // text-align: center;
      margin: 0 auto;
      padding: 0 42px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      margin-bottom: 20px;
      color: $c_000;
      .list {
        // height: 25px;
        line-height: 24px;
      }
      .place {
        text-align: center;
        // width: 124px;
        padding: 0 10px;
        height: 26px;
        display: inline-block;
        font-size: 15px;
        cursor: pointer;
        font-family: EperFontLight;
      }
      .place.active {
        // text-align: center;
        color: $c_6DB;
        border: 1px solid $c_6DB;
        border-radius: 15px;
      }
    }
    .otherCity {
      padding: 0 42px;
      box-sizing: border-box;
      text-align: left;
      margin-bottom: 26px;
      color: $c_000;
      .key {
        font-size: 18px;
        padding: 0px;
        box-sizing: border-box;
        margin-bottom: 10px;
        display: flex;
        .keyItem {
          float: left;
          width: 38px;
          margin-left: 6px;
          cursor: pointer;
        }
        .keyItem.active {
          color: $c_6DB;
        }
      }
      .keycity {
        width: 100%;
        padding: 16px 50px;
        box-sizing: border-box;
        background: #f7f9f8;
        border-radius: 10px;
        font-size: 15px;
        position: relative;
        color: $c_000;
        .cityItem {
          margin-right: 13px;
          font-size: 14px;
          cursor: pointer;
        }
        .cityItem.active {
          color: $c_6DB;
        }
      }
      .keycity .icon {
        position: absolute;
        left: 4px;
        width: 0px;
        height: 0px;
        content: "";
        top: -18px;
        border-top: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #f7f9f8;
        border-left: 10px solid transparent;
      }
    }
    .btnBox {
      display: flex;
      justify-content: space-around;
      padding: 0 160px;
      box-sizing: border-box;
      .confirm {
        width: 199px;
        height: 36px;
        // border: 1px solid $c_6DB;
        // background: $c_6DB;
        border: 1px solid #000;
        background: #000;
        color: #fff;
        border-radius: 20px;
        // margin: 0 auto;
        text-align: center;
        line-height: 36px;
        font-size: 18px;
        cursor: pointer;
      }
      .confirm.active {
        // background: #000;
        color: #fff;
      }
      .cancel {
        width: 200px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        font-size: 18px;
        border-radius: 20px;
        cursor: pointer;

        border: 1px solid #000;
      }
    }

    // ======================
    // 配送方式
    .deliverbox {
      width: 100%;
      .jian {
        display: flex;
        justify-content: center;
        .jiansty {
          width: 30px;
          height: 30px;
        }
      }
      .titleBox {
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          position: relative;
          text-align: center;
          font-size: 25px;
          font-family: Montserrat;
          font-weight: 600;
          color: #6fbf59;
          text-align: center;
        }
        .cictyname {
          position: absolute;
          width: fit-content;
          // width: 122px;
          height: 27px;
          position: absolute;
          right: 190px;
          text-align: center;
          padding: 0 6px;
          box-sizing: border-box;

          background: #ffffff;
          font-size: 15px;
          border-radius: 20px;
          border: 2px solid #6fbe53;
        }
      }
      .dechang {
        width: 100%;
        text-align: center;
        margin-top: 14px;
        cursor: pointer;
        span {
          font-size: 15px;
          text-decoration: underline;
        }
      }
      .twoways {
        margin-top: 10px;
        display: flex;
        cursor: pointer;

        justify-content: space-around;
        .waysty {
          width: 347px;
        }
      }
      .waysbtn {
        width: 100%;
        padding: 0 200px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
        .sure {
          width: 199px;
          height: 36px;
          border: 1px solid $c_6DB;
          background: $c_6DB;
          color: #fff;
          border-radius: 20px;
          text-align: center;
          line-height: 36px;
          font-size: 18px;
          cursor: pointer;
        }
        .del {
          width: 200px;
          height: 36px;
          text-align: center;
          line-height: 36px;
          font-size: 18px;
          border-radius: 20px;
          cursor: pointer;

          border: 1px solid #000;
        }
      }
    }

    // 配送方式
  }
}
.app-cover {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  .app-pop {
    width: 979px;
    height: 510px;
    margin: 180px auto;
    background: #fff;
    border-radius: 20px;
    padding: 0px 0 0px;
    box-sizing: border-box;
    .inner {
      width: 979px;
      height: 510px;
      padding: 100px;
      box-sizing: border-box;
      border-radius: 20px;
      background: url(../../assets/img-left.png) bottom left no-repeat,
        url(../../assets/img-right.png) bottom right no-repeat;
      text-align: center;
      h2 {
        font-size: 30px;
        color: $c_6DB;
      }
      .desc {
        font-weight: bold;
        padding: 20px 0;
      }
      .btn {
        display: block;
        margin: 30px auto;
        background-color: $c_6DB;
        color: #fff;
        font-size: 16px;
        width: 140px;
        padding: 5px 0;
        border-radius: 20px;
        cursor: pointer;
      }
    }
    .confirm {
      width: 199px;
      height: 36px;
      border: 1px solid #000;
      border-radius: 20px;
      margin: 0 auto;
      text-align: center;
      line-height: 36px;
      font-size: 18px;
      cursor: pointer;
    }
    .confirm.active {
      border: 3px solid #000;
      line-height: 33px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/selectCity.vue